import { __assign } from "tslib";
import { connect } from 'react-redux';
import { withCursor } from '../Stream';
import { getIsLoggedIn } from '../publicSession/selectors';
import { changeOrder, threadUpdated, streamIdChanged } from './actionCreators';
import { getThreadState } from './selectors';
import { pushCommentsModal } from '../Modals/redux/actionCreators';
var mapStateToProps = function (state, ownProps) {
    var commentableTypeId = ownProps.commentableTypeId, commentableItemId = ownProps.commentableItemId, parentId = ownProps.parentId;
    var threadState = getThreadState(state, commentableTypeId, commentableItemId, parentId);
    return __assign(__assign({}, threadState), { isLoggedIn: getIsLoggedIn(state) });
};
var mapDispatchToProps = {
    onStreamIdChanged: streamIdChanged,
    fetchMore: withCursor.actions.fetch,
    fetchPrevious: withCursor.actions.fetchPrevious,
    onOrderChanged: changeOrder,
    onThreadUpdated: threadUpdated,
    onOpenCommentModal: pushCommentsModal,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=CommentThread.container.js.map